import axios from "axios";

// 현재 환경 변수가 무엇인지 브라우저 콘솔(F12)에 찍어봅니다.
// console.log("DEBUG: REACT_APP_API_BASE_URL =", process.env.REACT_APP_API_BASE_URL);

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const axiosClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: 1000000,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

export default axiosClient;